<template>
  <div class="indicators-view">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C"/>
    </template>
    <template v-else>

      <inner-navigation>
        <router-link to="/indicators/all">Все индикаторы</router-link>
      </inner-navigation>

      <component :is="tableType" @changePage="changePage"/>

      <!-- <paginator :model="meta.list_data"/> -->
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';

import * as tables from './tables';

export default {
  name: 'indicators-view',

  components: {
    TableElement,
    ...tables,
  },

  computed: {
    ...mapGetters({
      loading: 'config/loading',
      error: 'config/error',
      meta: 'config/meta',
    }),

    tableType() {
      return this.$route.meta.tableType;
    },
  },

  methods: {
    ...mapActions({
      changeParams: 'indicators/changeParams',
    }),

    changePage(skip) {
      this.changeParams({
        skip,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.indicators-view {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100%;
}
</style>
